<template>
  <v-snackbar
    v-model="snackbar"
    :color="(color ? color : '')"
    top
    style="z-index: 1000000000000 !important;"
  >
    {{ text }}

    <template v-slot:action="{ attrs }">
      <v-btn
        color="white"
        text
        v-bind="attrs"
        @click="close"
      >
        {{ $t('close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  export default {
    name: 'Snakbar',
    props: ['text', 'color', 'active'],
    data: () => ({
      snackbar: false,
    }),
    watch: {
      active (val, oldVal) {
        if (this.active) {
          this.snackbar = true
        }
      },
      snackbar: function () {
        if (this.snackbar === false) {
          this.$emit('input', this.snackbar)
          this.snakbar = false
        }
      },
    },
    methods: {
      close () {
        this.snackbar = false
        this.$emit('input', this.snackbar)
      },
    },
  }
</script>

<style scoped>

</style>
